import React, { useState } from 'react';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import { generateId } from '../utility/functions';
import Table from '../table/Table';
import useMetronome from '../utility/useMetronome';

const TopExpressPassUsers = ({ ...props }) => {

    const [data, setData] = useState([]);
    const [fetchData, setFetchData] = useState(5);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.topExpressPass)
                .then(res => setData(res))
                .catch(ex => console.error(ex))
        }
    }, 60000)

    return (
        <Table
            config={{
                disableHeaderSearch: true,
                disableTableControls: true,
                disableMobileView: true,
                data: data,
                headers: [
                    {
                        label: 'User',
                        propKey: 'contactName',
                    }, {
                        label: 'Club',
                        propKey: 'award',
                    }, {
                        label: 'Uses',
                        propKey: 'uses',
                    }
                ],
                renderFormat: (e) => (
                    <tr key={generateId()}>
                        <td>{e.contactName}</td>
                        <td>{e.award}</td>
                        <td>{e.uses}</td>
                    </tr>
                )
            }}
        />
    );
}

export default TopExpressPassUsers;